// extracted by mini-css-extract-plugin
export var downloadAssets = "downloadAssets-module--downloadAssets--54791";
export var eyebrow = "downloadAssets-module--eyebrow--8f80b";
export var fileIcon = "downloadAssets-module--fileIcon--f7914";
export var fileImage = "downloadAssets-module--fileImage--cef16";
export var fileInfo = "downloadAssets-module--fileInfo--86995";
export var fileItem = "downloadAssets-module--fileItem--a8217";
export var fileLabel = "downloadAssets-module--fileLabel--6100a";
export var fileLink = "downloadAssets-module--fileLink--4262a";
export var filesList = "downloadAssets-module--filesList--7c401";
export var label = "downloadAssets-module--label--c8716";